module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/3-1-76617ab83c87703ad7aa97a3a102fbe6.png";